// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"80":"datasetQuery","718":"datasetEdit"}[chunkId] + "." + {"80":"fa18b9d0","718":"b82e2c17"}[chunkId] + ".css";
};